import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { styled, useTheme } from '@mui/material';
import React from 'react';
import { alpha } from '@mui/material/styles';

var StyledContainer = styled('div', {})(function () { return ({
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    columnGap: 7,
    '*': {
        mixBlendMode: 'unset !important',
    },
    '.outOfStock-pill': {
        textWrap: 'nowrap',
        borderRadius: 25,
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
        display: 'flex',
        alignItems: 'center',
        ':hover': {
            cursor: 'default',
        },
    },
}); });
var StyledOutOfStockPill = styled('div')(function (_a) {
    var theme = _a.theme, outOfStockTextColor = _a.outOfStockTextColor, outOfStockBackgroundColor = _a.outOfStockBackgroundColor;
    return ({
        borderRadius: '999px',
        backgroundColor: outOfStockBackgroundColor || alpha(theme.palette.secondary.main, 0.2),
        color: outOfStockTextColor || theme.palette.primary.main,
        display: 'flex',
        width: 'fit-content',
    });
});
var OutOfStockPill = function (_a) {
    var _b, _c;
    var _d = _a.containerStyle, containerStyleOverride = _d === void 0 ? {} : _d, _e = _a.pillContainerStyle, pillContainerStyle = _e === void 0 ? {} : _e, _f = _a.baseFontSize, baseFontSize = _f === void 0 ? 14 : _f;
    var theme = useTheme();
    var pillDefaultPadding = {
        paddingTop: baseFontSize / 3,
        paddingLeft: baseFontSize * 0.95,
        paddingBottom: baseFontSize / 3,
        paddingRight: baseFontSize * 0.95,
    };
    var outOfStockTextColor = (_b = theme.customRewardPillColor) === null || _b === void 0 ? void 0 : _b.outOfStockText;
    var outOfStockBackgroundColor = (_c = theme.customRewardPillColor) === null || _c === void 0 ? void 0 : _c.outOfStock;
    return (React.createElement(StyledContainer, { style: __assign({ display: 'block', width: 'fit-content' }, containerStyleOverride) },
        React.createElement(StyledOutOfStockPill, { outOfStockTextColor: outOfStockTextColor, outOfStockBackgroundColor: outOfStockBackgroundColor },
            React.createElement("div", { className: "outOfStock-pill", style: __assign(__assign(__assign({}, pillDefaultPadding), pillContainerStyle), { fontWeight: 600 }) }, 'Out of stock'))));
};

export { OutOfStockPill };
//# sourceMappingURL=OutOfStockPill.js.map
